import _styled from '@emotion/styled/base';
import { Flex } from '../Flex/index.js';
import { getDensityContentSpacing, getDensityPadding } from '../shared/Density/utils.js';
import { Spacer, shorthandSpacingCss } from '../primitives/Spacer/index.js';
import { motion, density } from '@hubble/tokens/web';

const StyledFlex = _styled(Flex, {
  target: "ehl9t2e4"
})({
  name: "2qga7i",
  styles: "text-align:right"
} );
const ListItemHr = _styled(Spacer, {
  target: "ehl9t2e3"
})("border:0;border-bottom:1px solid ", ({
  theme
}) => theme.colorScheme.border.primary, ";");
const ListItemWrapper = _styled("li", {
  target: "ehl9t2e2"
})("list-style:none;", ({
  hasClickableElements
}) => hasClickableElements && `
    position: relative;
    z-index: 0;
  `, ">a,>button{display:block;cursor:pointer;transition:background-color ", motion.duration.fast, " ", motion.timing.easeInOut, ";&::before{content:'';position:absolute;z-index:-1;transition:background-color ", motion.duration.fast, " ", motion.timing.easeInOut, ";", ({
  density
}) => density ? getDensityContentSpacing(density) : 'inset: 0px', ";}&:hover,&:focus{&::before{background-color:", ({
  theme
}) => theme.colorScheme.list.background.hover, ";}}&:active{&::before{background-color:", ({
  theme
}) => theme.colorScheme.list.background.active, ";}}&:focus{outline:none;&::before{background-color:", ({
  theme
}) => theme.colorScheme.list.background.focus, ";}}}", shorthandSpacingCss, ";");
const ListItemInner = _styled("span", {
  target: "ehl9t2e1"
})({
  name: "7q6kxf",
  styles: "background-color:transparent;border:none;padding:0;text-align:left;width:100%"
} );
const FlexWrapper = _styled(Flex, {
  target: "ehl9t2e0"
})("align-items:center;", ({
  density: densityType
}) => densityType && `
    ${getDensityPadding(densityType)}
    gap: ${density.contentItems.gap[densityType]};
    `, ";");

export { FlexWrapper, ListItemHr, ListItemInner, ListItemWrapper, StyledFlex };
